
/*
 * facecloud后台index页面
 * @Author: ljb
 * @Date: 2018-03-26 10:18:23
 * @Last Modified by: ljb
 * @Last Modified time: 2019-11-18 15:49:49
 */
<style lang="less" rel="stylesheet/less" type="text/less">
.leftNavigation {
  i {
    font-size: 18px;
  }
}
</style>
<template>
	<div class="leftNavigation">
		<Col class="leftNavigation">
		<Menu
			theme="light"
			mode="vertical"
			class="leftNavigation"
			style="width:100%;"
			@on-select="toPath"
            accordion
		>
			<!-- <MenuItem name="panx-overview">
			<Icon type="ios-home" />概览
        </MenuItem> -->
			<Submenu name="APP-management">
				<template slot="title">
					<Icon type="ios-paper" />应用管理
				</template>
				<MenuItem name="panx-api-key">
				<Icon type="ios-key" />API KEY
                </MenuItem>
                <MenuItem name="panx-financial-center">
				<Icon type="logo-yen" />财务中心
                </MenuItem>
                 <MenuItem name="panx-billing-plan">
				<Icon type="logo-usd" />计费方案
                </MenuItem>
			</Submenu>

		</Menu>
    </Col>
	</div>
</template>

<script type="text/babel">
import qs from 'qs';

export default {
	methods: {
		// 跳转路由并且提交跳转的name到vuex,并备份到sessionStorage
		toPath(path) {
			this.$router.push({ name: `${path}` });

			this.$store.commit('addList', path);
			sessionStorage.setItem(
				'breadcrumbList',
				JSON.stringify([{ name: path }]),
			);
		},
	},
};
</script>
